import type { AnnotationData } from '@/modules/Editor/AnnotationData'
import type { Annotation } from '@/modules/Editor/models/annotation/Annotation'
import { isVideoAnnotation } from '@/modules/Editor/models/annotation/annotationKindValidator'
import { isReformattedDICOMView } from '@/modules/Editor/utils/radiology/isReformattedDicomView'
import type { View } from '@/modules/Editor/views/view'

/** Images, and DICOM with a single slice viewed in its acquisition plane. */
export const isSliceableView = (view: View): boolean =>
  !view.fileManager.isProcessedAsVideo ||
  (view.fileManager.isDicom && view.totalFrames === 1 && !isReformattedDICOMView(view))

/** The shape a slice edits: an image annotation's data, or a DICOM annotation's current frame. */
export const sliceData = (view: View, target: Annotation): AnnotationData | undefined =>
  isVideoAnnotation(target) ? target.data.frames[view.currentFrameIndex] : target.data

/** `target.data` with the sliced shape replaced by `data`. */
export const withSliceData = (
  view: View,
  target: Annotation,
  data: Partial<AnnotationData>,
): Annotation['data'] => {
  if (!isVideoAnnotation(target)) {
    return { ...target.data, ...data }
  }
  const frame = view.currentFrameIndex
  return {
    ...target.data,
    frames: { ...target.data.frames, [frame]: { ...target.data.frames[frame], ...data } },
  }
}
